/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseAvailabilityDto } from '../../models/response-availability-dto';

export interface GoogleCalendarAvailabilityControllerFindAllByEmail$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;
}

export function googleCalendarAvailabilityControllerFindAllByEmail(http: HttpClient, rootUrl: string, params: GoogleCalendarAvailabilityControllerFindAllByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAvailabilityDto>> {
  const rb = new RequestBuilder(rootUrl, googleCalendarAvailabilityControllerFindAllByEmail.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseAvailabilityDto>;
    })
  );
}

googleCalendarAvailabilityControllerFindAllByEmail.PATH = '/thalea-google-events/google-calendar-availability/{tenant}/{email}';
